import { type MCPServerInfo } from '../../types';

const SlackBetaServer: MCPServerInfo = {
  serverId: 'SLACK_BETA',
  name: 'Slack Beta',
  slug: 'slack-beta',
  description: 'Slack Beta MCP Server',
  source: {
    sourceType: 'REPOSITORY',
    type: 'NATOMA',
    repositoryUrl: 'mcp/slack-mcp-server-next:latest',
    commitSha: '119bf16',
    packageType: 'npm',
    packageName: ''
  },
  authenticationType: 'OAUTH',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  }
};

export default SlackBetaServer;
